module.exports = __webpack_public_path__ + "img/Enzymotherapy04.3bfbf8a0.jpg";